import { createAction } from '@reduxjs/toolkit';

export const TOGGLE_CTA_DRAWER = 'TOGGLE_CTA_DRAWER';

export const toggleCtaDrawer = createAction(TOGGLE_CTA_DRAWER, (type?: string) => ({
  payload: { type },
}));
